import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface MeterDetailCustomer {
  id: number;
  allSensorsGroupId: number | null;
  accountName: string;
  accountId: string | null;
  salesforceId: string | null;
  metronId: string | null;
  accountType: string | null;
  realEstateAccountType: string | null;
  active: boolean;
}

export interface MeterDetailInfo {
  // sensor_daily_summary_materialized
  sensorId: number;
  deviceId: string;
  rate: number | null;
  min: number | null;
  avg30Day: number | null;
  avg60To30Day: number | null;
  flowConditions: string[] | null;
  sensorConditions: string[] | null;
  address: string | null;
  consumerName: string | null;
  consumerId: string | null;
  deviceDescription: string | null;
  leakRate: number | null;
  backflowRate: number | null;
  irrigationRate: number | null;
  materializedDate: string | null;
  // sensor
  meterSize: string | null;
  // unified_metadata
  meterType: string | null;
  umMeterSize: string | null;
  registerType: string | null;
  registerBrand: string | null;
  logInterval: number | null;
  turnDivider: number | null;
  indexRatio: number | null;
  transmitScaling: number | null;
  hardwareVersion: string | null;
  firmwareVersion: string | null;
  lastReadDate: string | null;
  lcdRead: string | null;
  readUnits: string | null;
  firstDigitPosition: number | null;
  decimalPosition: number | null;
  numLcdUnderscores: number | null;
  signalQuality: number[] | null;
  rssi: number | null;
  broadcastOffset: number | null;
  numLteTxAttempts: number | null;
  numSetsPerformed: number | null;
  gateways: string | null;
  metadataUpdatedAt: string | null;
  // location
  wsConsumerId: string | null;
  wsConsumerName: string | null;
  wsAddress: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  // watersignal_device_info
  wdiDeviceDescription: string | null;
  sensorDescription: string | null;
  wdiMeterSize: string | null;
  meterBrand: string | null;
  deviceSerial: string | null;
}

interface MeterDetailResponse {
  detail: MeterDetailInfo | null;
  customers: MeterDetailCustomer[];
}

export function useMeterDetail(sensorId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-detail', sensorId],
    queryFn: () => apiClient.get<MeterDetailResponse>(`meters/${sensorId}/detail`),
    enabled: !!sensorId,
  });
}
